/**
 * OCTOPUS — WorkHoldBadge (RC-2, histerese de saída das etapas de trabalho)
 *
 * Chip com CONTAGEM REGRESSIVA exibido quando o worker está segurando a saída
 * de uma etapa de trabalho (carregando/descarregando): o `work_hold` do
 * lab_activity_state expõe deadline_epoch (fim da janela) e deconfig_at
 * (instante da desconfiguração). Se a etapa não reconfigurar até o deadline,
 * o worker fecha RETROATIVAMENTE em deconfig_at.
 *
 * Só exibição — o countdown local é derivado de deadline_epoch (server-
 * authoritative); nenhuma recomputação de telemetria (INV-UI-TRAIL-001).
 */
import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';

const STAGE_LABEL = { carregando: 'Carregando', descarregando: 'Descarregando' };

const fmtMMSS = (s) => {
  const total = Math.max(0, Math.round(s));
  const mm = Math.floor(total / 60);
  const ss = total % 60;
  return `${mm}:${String(ss).padStart(2, '0')}`;
};

const WorkHoldBadge = ({ workHold, className = '' }) => {
  const deadline = workHold?.deadline_epoch;
  const [remaining, setRemaining] = useState(null);

  useEffect(() => {
    if (deadline == null) {
      setRemaining(null);
      return undefined;
    }
    const tick = () => setRemaining(deadline - Date.now() / 1000);
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [deadline]);

  if (!workHold || remaining == null) return null;

  const stage = STAGE_LABEL[workHold.stage] || workHold.stage;
  return (
    <div
      className={`flex items-center gap-2 rounded-md border border-amber-300 bg-amber-50 dark:bg-amber-950/30 dark:border-amber-700 px-3 py-2 text-amber-800 dark:text-amber-300 ${className}`}
      data-testid="work-hold-badge"
    >
      <Timer className="h-4 w-4 shrink-0 animate-pulse" />
      <div className="text-sm leading-tight">
        <span className="font-medium">{stage} em espera</span>
        {remaining > 0 ? (
          <>
            {' — fecha retroativo em '}
            <span className="font-mono font-semibold">{fmtMMSS(remaining)}</span>
            {' se não retomar'}
          </>
        ) : (
          ' — janela expirada, fechando retroativamente…'
        )}
      </div>
    </div>
  );
};

export default WorkHoldBadge;
